module.exports = __webpack_public_path__ + "img/swap.4a7b3eba.svg";